/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetCompetitionRow } from '../openapi-types.gen.js';
import { type useGetCompetitionArgs, useGetCompetitionSpec } from '../specs/competitions.spec.gen.js';

export type { GetCompetitionRow } from '../openapi-types.gen.js';
export type { useGetCompetitionArgs } from '../specs/competitions.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): competitionId.
 */
const _useGetCompetition = createHook(useGetCompetitionSpec);
export const useGetCompetition = _useGetCompetition as (args: useGetCompetitionArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetCompetition>;


/**
 * Hover/intent prefetch companion for `useGetCompetition`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetCompetition();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetCompetition = createPrefetchHook(useGetCompetitionSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetCompetitionArgs>;
